export default "__VITE_ASSET__CBQIP_vy__"